// @flow
import React from 'react';

import { withTranslation } from '@i18n';

import type { Props, StrengthType } from './types';

import { getStrength } from './utils';
import { STRONG, MEDIUM, WEAK } from './constants';

import {
  StyledCover, StyledRow, StyledLabel, StyledStrength, StyledIndicator
} from './styles';

const PasswordStrength = ({ password = '', t }: Props) => {
  const strength: StrengthType = getStrength(password);

  const indicator1 = [WEAK, MEDIUM, STRONG].includes(strength);
  const indicator2 = [MEDIUM, STRONG].includes(strength);
  const indicator3 = [STRONG].includes(strength);

  return (
    <StyledCover>
      <StyledRow>
        <StyledLabel>{t('PasswordStrength.Label')}</StyledLabel>

        <StyledStrength strength={strength}>
          {t(`PasswordStrength.Strength.${strength}`)}
        </StyledStrength>
      </StyledRow>

      <StyledRow>
        <StyledIndicator isActive={indicator1} strength={strength} />
        <StyledIndicator isActive={indicator2} strength={strength} />
        <StyledIndicator isActive={indicator3} strength={strength} />
      </StyledRow>
    </StyledCover>
  );
};

export default withTranslation('common')(PasswordStrength);
